import { render, staticRenderFns } from "./LabelInsert.vue?vue&type=template&id=5b20084c&scoped=true&"
import script from "./LabelInsert.vue?vue&type=script&lang=js&"
export * from "./LabelInsert.vue?vue&type=script&lang=js&"
import style0 from "./LabelInsert.vue?vue&type=style&index=0&id=5b20084c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b20084c",
  null
  
)

export default component.exports